import PropTypes from 'prop-types';

const ResetTripButton = ({ onResetClick, buttonText }) => (
  <button
    type="button"
    className="flex-auto text-right leading-5 text-theme underline focus:outline-none"
    onClick={onResetClick}
  >
    {buttonText}
  </button>
);

ResetTripButton.propTypes = {
  onResetClick: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};

ResetTripButton.defaultProps = {
  buttonText: 'Reset',
};

export default ResetTripButton;
